var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg35(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "url(#paint0_linear_2460_2497)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6953 32.5V20.7422L21.6211 27.461V32.5196H23.9063V26.9922C23.9063 26.582 23.7109 26.1719 23.3789 25.9375L12.5391 17.7735C11.6602 17.1094 10.4102 17.7344 10.4102 18.8281V32.5H12.6953ZM37.3828 32.5V20.7422L28.457 27.461V32.5196H26.1719V26.9922C26.1719 26.582 26.3672 26.1719 26.6992 25.9375L37.5195 17.7735C38.3984 17.1094 39.6484 17.7344 39.6484 18.8281V32.5H37.3828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2497",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FA89B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ACEBB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg35);
export default __webpack_public_path__ + "static/media/35.4cbe122808fae000447941e6b99f1a3e.svg";
export { ForwardRef as ReactComponent };